import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-confirmation-alert',
    templateUrl: './confirmation-alert.component.html',
    styleUrls: ['./confirmation-alert.component.scss'],
    standalone: false
})
export class ConfirmationAlertComponent implements OnInit {
  // v13-migration placeholder (Ivy basic template-check requires the symbol to exist; undefined at runtime == v12 behaviour; Phase 2: align template)
  title: any;

  @Input() 
  message?: string;

  @Input() 
  showAlert?: Boolean;

  
  @Output() 
  response: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
   
  }

  accept(){
    this.response.emit('Yes')
  }
  reject(){
    this.response.emit('No')
  }

}
